import { StateCreator } from 'zustand';

import { LmmSidepanelAttributes, LmmSidepanelStore } from './types/LmmSidepanelStore';

const defaultSidepanel = (): LmmSidepanelAttributes =>
  structuredClone({
    show: false,
    view: 'voorraad',
    lmmVoorraad: undefined,
    lmmTijdstip: undefined,
    vorigeLmmVoorraad: undefined,
    vorigeLmmTijdstip: undefined,
    geselecteerdeDefect: undefined,
  });

const lmmSidepanelStateCreator: StateCreator<LmmSidepanelStore> = (set, get, __) => ({
  sidepanel: defaultSidepanel(),
  async setSidepanelLmmVoorraad(lmmVoorraad, lmmTijdstip) {
    const currentShow = get().sidepanel.show;
    const setState = () =>
      set(() => ({
        sidepanel: {
          show: true,
          view: 'voorraad',
          lmmVoorraad,
          lmmTijdstip,
          vorigeLmmVoorraad: undefined,
          vorigeLmmTijdstip: undefined,
          geselecteerdeDefect: undefined,
        },
      }));
    if (currentShow) {
      get().closeSidepanel();
      setTimeout(setState, 200);
    } else {
      setState();
    }
  },
  setSidepanelLmmMaterieel(defect) {
    set((state) => ({
      sidepanel: {
        ...state.sidepanel,
        show: true,
        view: 'materieel',
        vorigeLmmVoorraad:
          state.sidepanel.view === 'voorraad' ? state.sidepanel.lmmVoorraad : state.sidepanel.vorigeLmmVoorraad,
        vorigeLmmTijdstip:
          state.sidepanel.view === 'voorraad' ? state.sidepanel.lmmTijdstip : state.sidepanel.vorigeLmmTijdstip,
        geselecteerdeDefect: defect,
      },
    }));
  },
  restoreSidepanelLmmVoorraad() {
    set((state) => {
      if (!state.sidepanel.vorigeLmmVoorraad) return { sidepanel: state.sidepanel };
      return {
        sidepanel: {
          ...state.sidepanel,
          show: true,
          view: 'voorraad',
          lmmVoorraad: state.sidepanel.vorigeLmmVoorraad,
          lmmTijdstip: state.sidepanel.vorigeLmmTijdstip,
          vorigeLmmVoorraad: undefined,
          vorigeLmmTijdstip: undefined,
          geselecteerdeDefect: undefined,
        },
      };
    });
  },
  closeSidepanel() {
    set({
      sidepanel: defaultSidepanel(),
    });
  },
  resetLmmSidepanel() {
    set({
      sidepanel: defaultSidepanel(),
    });
  },
});

export default lmmSidepanelStateCreator;
